export default __webpack_public_path__ + "static/about-us-leanne-0b96359032782d693b0365e745d15449.webp";